import React, { useState, lazy } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { addWishlistFriend } from 'Redux/ducks/wishlist';
import { toggleLoginModal } from 'Redux/ducks/modal';
import LazyModal from 'Components/Utility/LazyModal';
import 'Components/Wishlist/WishlistFriendLink.scss';

const RemoveFriend = lazy(() => import(/* webpackChunkName: "RemoveFriend" */ 'Components/Wishlist/RemoveFriend'));

const WishlistFriendLink = ({
  wishlistDisplayName,
  wishlistId,
  addWishlistFriend: propAddWishlistFriend,
  friends,
  toggleLoginModal: propsToggleLoginModal,
  authenticated,
  selected,
  fromAccount,
}) => {
  const [addingFriend, setAddingFriend] = useState(false);
  const [modalOpen, setModalOpen] = useState();

  const rememberListClick = async () => {
    if (!authenticated) return propsToggleLoginModal();
    setAddingFriend(true);
    await propAddWishlistFriend(wishlistId);
    return true;
  };

  const removeListClick = async () => {
    setAddingFriend(false);
    setModalOpen(!modalOpen);
  };

  const isFriend = !!friends.find(friend => friend.wishlist_id === wishlistId);
  let friendLink = `/wishlist/${wishlistId}`;
  if (fromAccount) friendLink = `/account/wishlist/${wishlistId}`;

  return (
    <div className={classNames('wishlist-friend-link faux-block-link', { selected })}>
      <div className="friend-display-name">
        {wishlistDisplayName}
      </div>
      {isFriend &&
        <div className="friend-actions-container">
          <div className="friend-action">
            <Link className="btn btn-primary-link faux-block-link__overlay-link" to={friendLink}>
              <FormattedMessage id="wishlistfriendlink.viewfriend" defaultMessage="View List" />
            </Link>
          </div>
          <div className="friend-action">
            <button className="btn btn-secondary-link" onClick={() => removeListClick()}>
              <FormattedMessage id="wishlistfriendlink.removefriend" defaultMessage="Remove List" />
            </button>
          </div>
        </div>
      }
      {!isFriend &&
        <div className="remember-btn-container">
          <button className="btn btn-primary remember-btn" disabled={addingFriend} onClick={() => rememberListClick()}>
            <FormattedMessage id="wishlistfriendlink.rememberlist" defaultMessage="Remember List" />
          </button>
        </div>
      }
      <LazyModal
        centered
        open={modalOpen}
        setOpen={setModalOpen}
        className="simple-modal"
      >
        <RemoveFriend
          wishlistDisplayName={wishlistDisplayName}
          wishlistId={wishlistId}
          setOpen={setModalOpen}
        />
      </LazyModal>
    </div>
  );
};

WishlistFriendLink.propTypes = {
  wishlistDisplayName: PropTypes.string,
  wishlistId: PropTypes.string,
  addWishlistFriend: PropTypes.func.isRequired,
  toggleLoginModal: PropTypes.func.isRequired,
  friends: PropTypes.arrayOf(PropTypes.object),
  authenticated: PropTypes.bool,
  selected: PropTypes.bool,
  fromAccount: PropTypes.bool,
};
WishlistFriendLink.defaultProps = {
  friends: [],
  wishlistDisplayName: '',
  wishlistId: '',
  authenticated: false,
  selected: false,
  fromAccount: false,
};

const mapStateToProps =
({
  auth: { authenticated },
  wishlist: { friends },
}) => ({
  authenticated,
  friends,
});

const mapDispatchToProps = {
  addWishlistFriend,
  toggleLoginModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(WishlistFriendLink);
